import { axios } from 'common/axios';
import { isEmpty, join } from 'lodash';

export const fetchApplicationsFormsSchemas = async ({
  token,
  tenantName,
}: {
  token: string;
  tenantName: string;
}): Promise<any> => {
  const queryParams = [];

  if (token) {
    queryParams.push(`token=${token}`);
  }

  if (tenantName) {
    queryParams.push(`tenant_name=${tenantName}`);
  }

  const queryParamsString = isEmpty(queryParams)
    ? ''
    : `?${join(queryParams, '&')}`;

  const url = `/api/applications/forms-schemas${queryParamsString}`;
  const { data } = await axios.get(url);

  return data;
};
